/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { adminLogControllerSearchOffset } from '../fn/admin-log/admin-log-controller-search-offset';
import { AdminLogControllerSearchOffset$Params } from '../fn/admin-log/admin-log-controller-search-offset';
import { AdminLogSearchResponseDto } from '../models/admin-log-search-response-dto';

@Injectable({ providedIn: 'root' })
export class AdminLogService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `adminLogControllerSearchOffset()` */
  static readonly AdminLogControllerSearchOffsetPath = '/api/admin-log/search/offset';

  /**
   * 관리자 로그 오프셋 기반 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminLogControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminLogControllerSearchOffset$Response(params: AdminLogControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminLogSearchResponseDto>> {
    return adminLogControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 로그 오프셋 기반 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminLogControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminLogControllerSearchOffset(params: AdminLogControllerSearchOffset$Params, context?: HttpContext): Observable<AdminLogSearchResponseDto> {
    return this.adminLogControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdminLogSearchResponseDto>): AdminLogSearchResponseDto => r.body)
    );
  }

}
